import React from 'react';
import { Section } from './Section';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Manual de Intimidad Post-Bebé',
    desc: "Reencuentro y reconexión. De 'roommates' a pareja otra vez.",
    img: 'https://cdn.magicpatterns.com/uploads/wFuZiUXNm21CNg1y1dVQFe/ChatGPT_Image_Jun_3,_2026,_08_09_03_PM.png'
  }, {
    title: 'Mamá Sin Inflamación',
    desc: 'El protocolo de 48 horas para recuperar tu cuerpo y energía.',
    img: 'https://cdn.magicpatterns.com/uploads/pzZJD9P8X5nLd91Xi1yyok/ChatGPT_Image_Jun_3,_2026,_08_20_05_PM.png'
  }, {
    title: 'Dormir en Crisis',
    desc: 'El protocolo de supervivencia para madres agotadas.',
    img: 'https://cdn.magicpatterns.com/uploads/aVX3Zx9DD6hmwR6cGcYTYs/ChatGPT_Image_Jun_3,_2026,_08_24_15_PM.png'
  }];
  return <Section className="py-20" data-id="element-9">
      <div className="text-center mb-16" data-id="element-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage/10 text-sage font-medium text-sm mb-6" data-id="element-11">
          <Gift className="w-4 h-4" data-id="element-12" />
          <span data-id="element-13">Incluidos sin costo adicional</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-14">
          Bonos Exclusivos
        </h2>
        <p className="text-xl text-brown-light italic font-serif" data-id="element-15">
          Cuando inviertes en RENACIDA hoy también recibes...
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto" data-id="element-16">
        {bonuses.map((bonus, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-17">
            <div className="relative w-full max-w-[280px] mb-6" data-id="element-18">
              <div className="absolute inset-0 bg-brush-sage opacity-0 group-hover:opacity-40 transition-opacity duration-500 rounded-full blur-2xl" data-id="element-19"></div>
              <img src={bonus.img} alt={bonus.title} className="w-full h-auto rounded-lg shadow-xl relative z-10 transform group-hover:-translate-y-2 transition-transform duration-500" data-id="element-20" />
              <div className="absolute -top-3 -right-3 z-20 bg-rose text-white text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-md transform rotate-6" data-id="element-21">
                Bono
              </div>
            </div>
            <h3 className="text-xl font-serif font-semibold mb-2 text-brown-dark" data-id="element-22">
              {bonus.title}
            </h3>
            <p className="text-brown-light mb-4" data-id="element-23">{bonus.desc}</p>
            <div className="inline-flex items-baseline gap-3" data-id="element-24">
              <span className="text-base text-brown-light/60 line-through" data-id="element-25">
                $27
              </span>
              <span className="font-serif text-xl font-semibold text-sage uppercase tracking-wide" data-id="element-26">
                Gratis
              </span>
            </div>
          </div>)}
      </div>

      <div className="mt-16 max-w-2xl mx-auto bg-cream-light rounded-2xl p-6 text-center border border-sage/20" data-id="element-27">
        <p className="text-brown-light text-sm uppercase tracking-wider mb-2" data-id="element-28">
          Valor total de los bonos
        </p>
        <p className="text-2xl font-serif text-brown-dark" data-id="element-29">
          <span className="line-through text-brown-light/60" data-id="element-30">$81</span>
          <span className="ml-3 text-sage font-semibold" data-id="element-31">Hoy: Gratis</span>
        </p>
      </div>
    </Section>;
}